import { useTranslation } from "react-i18next";

import { PreviousRecallRow, RecallHeader } from "components/Recalls/components/RecallsModal/components";
import "components/Recalls/components/RecallsModal/components/PreviousRecalls/PreviousRecalls.scss";
import { RECALL_ENTITY_STATUSSES } from "models";

import type { RecallEntity } from "models";

type PreviousRecallsProps = {
  hasOpenRecalls: boolean;
  rdwRecalls?: RecallEntity[];
  distrimateRecalls?: RecallEntity[];
};

export const PreviousRecalls = ({ distrimateRecalls, rdwRecalls, hasOpenRecalls }: PreviousRecallsProps) => {
  const { t } = useTranslation();

  const previousDistrimateRecalls = distrimateRecalls?.filter(recall => recall.status !== RECALL_ENTITY_STATUSSES.Unsettled);
  const previousRDWRecalls = rdwRecalls?.filter(recall => recall.status !== RECALL_ENTITY_STATUSSES.Unsettled);

  if (!previousDistrimateRecalls?.length && !previousRDWRecalls?.length) return null;

  return (
    <div className="PreviousRecalls">
      <RecallHeader title={t("v8_previous_recalls", "Previous Recalls")} selectOnly={false} showColumnNames={!hasOpenRecalls} />
      {previousDistrimateRecalls?.map(recall => (
        <PreviousRecallRow key={recall.id} label={`#${recall.campaign_code}  ${recall.campaign_name}`} status={recall.status} endDate={recall.close_date} />
      ))}

      {previousRDWRecalls?.map(recall => (
        <PreviousRecallRow key={recall.id} label={`#${recall.id}  ${recall.campaign_name}`} status={recall.status} />
      ))}
    </div>
  );
};
